import {call, put} from "redux-saga/effects";
import {getErrorFromMessage} from "services/utils/utils";
import {
    addNewPaymentMethodFailure,
    addNewPaymentMethodSuccess,
    deletePaymentMethodFailure, deletePaymentMethodSuccess
} from "store/reducer/payments/cards/reducer";
import * as api from "services/api";
import {addPaymentMethodSaga} from "store/reducer/payments/pay/saga";

export function* addNewPaymentMethodSaga({payload}) {
    try {
        yield call(addPaymentMethodSaga, {payload});
        payload.card.clear();
        yield put(addNewPaymentMethodSuccess());
    } catch (e) {
        yield put(addNewPaymentMethodFailure(getErrorFromMessage(e)));
    }
}
export function* removePaymentMethodSaga({payload}) {
    const {id} = payload;
    try {
        yield call([api, api.removePaymentMethodApi], id);
        yield put(deletePaymentMethodSuccess(id))
    } catch (e) {
        yield put(deletePaymentMethodFailure({error: getErrorFromMessage(e), id}));
    }
}